var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSenderos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2576 1076.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6b798;\n      }\n\n      .cls-2 {\n        fill: #81d6ac;\n      }\n\n      .cls-3 {\n        fill: #8df8ca;\n      }\n\n      .cls-4 {\n        fill: #1ebcef;\n      }\n\n      .cls-5 {\n        fill: #8bbad8;\n      }\n\n      .cls-6 {\n        fill: #f1898a;\n      }\n\n      .cls-7 {\n        fill: #d8bbf3;\n      }\n\n      .cls-8 {\n        fill: #febd7b;\n      }\n\n      .cls-9 {\n        fill: #f7f48b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M9-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2125.26 368.73 2088.52 365.95 2082.75 442.66 2118.33 445.66 2125.26 368.73"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "M9-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2052.94 362.95 2088.52 365.95 2082.75 442.66 2046.7 439.94 2052.94 362.95"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "M9-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2017.14 360.41 2052.94 362.95 2046.7 439.94 2010.96 437.04 2017.14 360.41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "M9-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1981.56 357.41 2017.14 360.41 2010.96 437.04 1975.56 434.19 1981.56 357.41"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "M9-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1945.52 354.4 1981.56 357.41 1975.56 434.19 1939.49 431.37 1945.52 354.4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "M9-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1909.71 351.63 1945.52 354.4 1939.49 431.37 1903.68 428.57 1909.71 351.63"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "M9-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1874.13 348.86 1909.71 351.63 1903.68 428.57 1867.94 425.77 1874.13 348.86"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "M9-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1838.55 345.62 1874.13 348.86 1867.94 425.77 1832.09 422.89 1838.55 345.62"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "M9-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1802.51 342.62 1838.55 345.62 1832.09 422.89 1796.78 419.94 1802.51 342.62"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "M9-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1766.93 340.08 1802.51 342.62 1796.78 419.94 1760.69 416.32 1766.93 340.08"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "M9-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1730.66 337.07 1766.93 340.08 1760.69 416.32 1724.47 413.36 1730.66 337.07"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "M9-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1695.08 334.3 1730.66 337.07 1724.47 413.36 1689.13 410.49 1695.08 334.3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "M9-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1659.5 331.76 1695.08 334.3 1689.13 410.49 1653.51 407.71 1659.5 331.76"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "M9-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1623.46 328.76 1659.5 331.76 1653.51 407.71 1617.71 404.89 1623.46 328.76"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "M9-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1587.65 325.75 1623.46 328.76 1617.71 404.89 1581.91 402.19 1587.65 325.75"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "M9-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1551.99 322.75 1587.65 325.75 1581.91 402.19 1545.58 399.46 1551.99 322.75"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "M9-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1516.03 320.21 1551.99 322.75 1545.58 399.46 1510.09 396.5 1516.03 320.21"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "M9-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1480.45 316.74 1516.03 320.21 1510.09 396.5 1474.24 393.71 1480.45 316.74"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "M9-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1444.41 313.97 1480.45 316.74 1474.24 393.71 1438.67 390.84 1444.41 313.97"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "M9-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1408.6 311.2 1444.41 313.97 1438.67 390.84 1402.62 388.37 1408.6 311.2"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "M9-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1340.21 306.12 1408.6 311.2 1402.62 388.37 1359.39 384.67 1340.21 306.12"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "M11-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2113.48 501.8 2078.36 498.8 2072.58 575.27 2107.93 578.27 2113.48 501.8"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "M11-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2042.55 496.02 2078.36 498.8 2072.58 575.27 2036.8 572.57 2042.55 496.02"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "M11-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2006.74 493.25 2042.55 496.02 2036.8 572.57 2000.44 569.84 2006.74 493.25"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "M11-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1971.16 490.25 1964.92 566.49 2000.44 569.84 2006.74 493.25 1971.16 490.25"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "M11-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1935.12 487.48 1928.65 564.18 1964.92 566.49 1971.16 490.25 1935.12 487.48"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "M11-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1899.08 484.47 1935.12 487.48 1928.65 564.18 1892.84 561.16 1899.08 484.47"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "M11-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1863.5 481.7 1857.49 558.17 1892.84 561.16 1899.08 484.47 1863.5 481.7"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "M11-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1827.92 478.7 1821.68 555.63 1857.49 558.17 1863.5 481.7 1827.92 478.7"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "M11-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1792.11 475.92 1785.87 552.86 1821.68 555.63 1827.15 478.64 1792.11 475.92"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "M11-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1756.07 472.92 1750.06 549.62 1785.87 552.86 1792.11 475.92 1756.07 472.92"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "M11-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1720.49 469.92 1714.25 546.62 1750.06 549.62 1756.07 472.92 1720.49 469.92"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "M11-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1684.22 467.15 1720.49 469.92 1714.25 546.62 1678.49 543.71 1684.22 467.15"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "M11-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1648.41 464.6 1684.22 467.15 1678.49 543.71 1642.41 541.01 1648.41 464.6"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "M11-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1612.83 461.37 1648.41 464.6 1642.41 541.01 1606.87 538.22 1612.83 461.37"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "M11-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1577.25 458.37 1612.83 461.37 1606.87 538.22 1570.78 535.42 1577.25 458.37"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "M11-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1541.21 455.59 1577.25 458.37 1570.78 535.42 1535.04 532.42 1541.21 455.59"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "M11-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1505.86 452.82 1541.21 455.59 1535.04 532.42 1499.68 529.58 1505.86 452.82"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "M11-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1469.59 449.82 1505.86 452.82 1499.68 529.58 1463.42 526.66 1469.59 449.82"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "M11-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1433.78 447.05 1469.59 449.82 1463.42 526.66 1427.52 523.77 1433.78 447.05"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "M11-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1373.48 442.43 1433.78 447.05 1427.52 523.77 1393.39 520.99 1373.48 442.43"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "M11-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1414.37 612.46 1455.96 615.7 1463.42 526.66 1393.39 520.99 1414.37 612.46"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "M11-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1499.68 529.58 1463.42 526.66 1455.96 615.7 1492.4 618.75 1499.68 529.58"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "M11-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1535.04 532.42 1499.68 529.58 1492.4 618.75 1528.04 620.55 1535.04 532.42"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "M11-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1570.78 535.42 1535.04 532.42 1528.04 620.55 1563.39 622.4 1570.78 535.42"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "M11-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1606.87 538.22 1570.78 535.42 1563.39 622.4 1599.66 624.48 1606.87 538.22"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "M11-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1642.41 541.01 1606.87 538.22 1599.66 624.48 1635.41 627.46 1642.41 541.01"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "M11-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1678.49 543.71 1642.41 541.01 1635.41 627.46 1671.05 629.33 1678.49 543.71"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "M11-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1714.25 546.62 1678.49 543.71 1671.05 629.33 1707.78 631.41 1714.25 546.62"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "M11-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1750.06 549.62 1714.25 546.62 1707.78 631.41 1743.38 634.12 1750.06 549.62"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "M11-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1785.87 552.86 1750.06 549.62 1743.38 634.12 1778.94 635.8 1785.87 552.86"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "M11-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1821.68 555.63 1785.87 552.86 1778.94 635.8 1814.45 638.77 1821.68 555.63"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "M11-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1857.49 558.17 1821.68 555.63 1814.45 638.77 1850.56 640.19 1857.49 558.17"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "M11-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1892.84 561.16 1857.49 558.17 1850.56 640.19 1885.91 642.04 1892.84 561.16"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "M11-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1928.65 564.18 1892.84 561.16 1885.91 642.04 1922.11 645.14 1928.65 564.18"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "M11-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1964.92 566.49 1928.65 564.18 1922.11 645.14 1957.99 646.89 1964.92 566.49"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "M11-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2000.44,569.84l-35.52-3.35-6.93,80.4s35.81,2.77,35.81,2.08,6.64-79.13,6.64-79.13Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "M11-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2036.8 572.57 2000.44 569.84 1993.8 648.97 2029.85 651.06 2036.8 572.57"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "M11-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2072.58 575.27 2036.8 572.57 2029.85 651.06 2066.34 653.13 2072.58 575.27"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "M11-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2107.93 578.27 2072.58 575.27 2066.34 653.13 2101.46 654.51 2107.93 578.27"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "M13-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1487.61 672.99 1430.08 672.99 1448.1 748.77 1481.6 750.62 1487.61 672.99"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "M13-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1523.65 676.23 1487.61 672.99 1481.6 750.62 1517.61 753.41 1523.65 676.23"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "M13-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1559.69 678.77 1523.65 676.23 1517.61 753.41 1553.22 755.24 1559.69 678.77"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "M13-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1595.27 680.85 1559.69 678.77 1553.22 755.24 1589.03 757.09 1595.27 680.85"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "M13-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1631.31 682.7 1595.27 680.85 1589.03 757.09 1625.04 760.04 1631.31 682.7"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "M13-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1667.12 685.24 1631.31 682.7 1625.04 760.04 1660.42 761.71 1667.12 685.24"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "M13-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1702.7 687.32 1667.12 685.24 1660.42 761.71 1696.23 763.56 1702.7 687.32"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "M13-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1738.51,689.63l-35.81-2.31s-6.53,76.99-6.47,76.24,36.04,2.54,36.04,2.54l6.24-76.47Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "M13-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1774.78 691.94 1738.51 689.63 1732.27 766.1 1768.28 769.04 1774.78 691.94"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "M13-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1810.36 694.02 1774.78 691.94 1768.28 769.04 1803.89 770.95 1810.36 694.02"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "M13-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1846.17 696.79 1810.36 694.02 1803.89 770.95 1840.17 772.8 1846.17 696.79"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "M13-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1882.21 698.64 1846.17 696.79 1840.17 772.8 1875.46 775.59 1882.21 698.64"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "M13-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1917.56 700.72 1882.21 698.64 1875.46 775.59 1911.78 777.19 1917.56 700.72"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "M13-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1953.14 702.8 1917.56 700.72 1911.78 777.19 1947.09 779.86 1953.14 702.8"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "M13-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1989.41 705.34 1953.14 702.8 1947.09 779.86 1983.17 781.58 1989.41 705.34"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "M13-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2025.22 707.19 1989.41 705.34 1983.17 781.58 2018.97 784.51 2025.22 707.19"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "M13-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2062.19 710.19 2025.22 707.19 2018.97 784.51 2055.72 785.97 2062.19 710.19"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "M13-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2097.3 712.73 2062.19 710.19 2055.72 785.97 2091.3 787.82 2097.3 712.73"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "M13-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2049.47 862.59 2085.06 864.98 2091.3 787.82 2055.72 785.97 2049.47 862.59"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "M13-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2013.44 861.05 2049.47 862.59 2055.72 785.97 2018.97 784.51 2013.44 861.05"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "M13-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1983.17 781.58 1977.63 858.51 2013.44 861.05 2018.97 784.51 1983.17 781.58"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "M13-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1947.09 779.86 1941.13 856.66 1977.63 858.51 1983.17 781.58 1947.09 779.86"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "M13-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1911.78 777.19 1905.55 854.12 1941.13 856.66 1947.09 779.86 1911.78 777.19"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "M13-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1875.46 775.59 1869.51 852.04 1905.55 854.12 1911.78 777.19 1875.46 775.59"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "M13-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1840.17 772.8 1833.7 849.5 1869.51 852.04 1875.46 775.59 1840.17 772.8"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "M13-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1803.89 770.95 1797.89 847.65 1833.7 849.5 1840.17 772.8 1803.89 770.95"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "M13-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1768.28 769.04 1762.08 845.34 1797.89 847.65 1803.89 770.95 1768.28 769.04"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "M13-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1732.27 766.1 1726 843.01 1762.08 845.34 1768.28 769.04 1732.27 766.1"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "M13-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1696.23 763.56 1690.23 841.19 1727 843.08 1732.27 766.1 1696.23 763.56"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "M13-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1660.42 761.71 1654.42 838.87 1690.23 841.19 1696.23 763.56 1660.42 761.71"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "M13-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1625.04 760.04 1618.61 836.33 1654.42 838.87 1660.42 761.71 1625.04 760.04"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "M13-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1589.03 757.09 1582.8 834.02 1618.61 836.33 1625.04 760.04 1589.03 757.09"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "M13-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1553.22 755.24 1546.76 832.18 1582.8 834.02 1589.03 757.09 1553.22 755.24"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "M13-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1517.61 753.41 1511.18 829.63 1546.76 832.18 1553.22 755.24 1517.61 753.41"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "M13-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1448.1 748.77 1466.82 826.63 1511.18 829.63 1517.61 753.41 1448.1 748.77"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "M15-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1542.25 887.85 1480.39 884.04 1501.01 966.35 1536.71 970.68 1542.25 887.85"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "M15-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1578.29 890.28 1542.25 887.85 1536.71 970.68 1571.53 974.49 1578.29 890.28"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "M15-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1614.16 892.53 1578.29 890.28 1571.53 974.49 1607.05 978.3 1614.16 892.53"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "M15-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1650.03 894.78 1614.16 892.53 1607.05 978.3 1642.75 982.46 1650.03 894.78"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "M15-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1685.72 897.04 1650.03 894.78 1642.75 982.46 1678.62 986.62 1685.72 897.04"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "M15-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1721.41 899.12 1685.72 897.04 1678.62 986.62 1713.79 990.26 1721.41 899.12"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "M15-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1757.11 901.54 1721.41 899.12 1713.79 990.26 1749.66 994.07 1757.11 901.54"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "M15-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1792.98 903.62 1757.11 901.54 1749.66 994.07 1785.53 998.23 1792.98 903.62"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "M15-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1829.36 906.22 1792.98 903.62 1785.53 998.23 1821.22 1001.87 1829.36 906.22"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "M15-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1865.23 907.95 1829.36 906.22 1821.22 1001.87 1857.26 1006.03 1865.23 907.95"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "M15-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1900.58 910.21 1865.23 907.95 1857.26 1006.03 1892.96 1009.66 1900.58 910.21"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "M15-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1936.79 912.29 1900.58 910.21 1892.96 1009.66 1928.82 1013.65 1936.79 912.29"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "M15-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1972.49 914.71 1936.79 912.29 1928.82 1013.65 1964.34 1017.29 1972.49 914.71"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "M15-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2008.53 916.79 1972.49 914.71 1964.34 1017.29 2000.21 1021.27 2008.53 916.79"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "M15-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2044.57 919.22 2008.53 916.79 2000.21 1021.27 2036.08 1025.26 2044.57 919.22"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "M15-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2079.4 921.64 2044.57 919.22 2036.08 1025.26 2071.08 1029.07 2079.4 921.64"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "M16-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2175.22 928.23 2139.35 925.11 2130.86 1035.31 2166.55 1039.64 2175.22 928.23"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "M16-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2210.74 931.35 2175.22 928.23 2166.55 1039.64 2201.9 1043.45 2210.74 931.35"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "M16-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2246.78 934.46 2210.74 931.35 2201.9 1043.45 2237.94 1047.61 2246.78 934.46"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "M16-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2283.34 936.89 2246.78 934.46 2237.94 1047.61 2273.64 1051.77 2283.34 936.89"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "M16-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2318.69 940.36 2283.34 936.89 2273.64 1051.77 2309.51 1056.1 2318.69 940.36"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "M16-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2355.08 943.13 2318.69 940.36 2309.51 1056.1 2345.59 1058.97 2355.08 943.13"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "M16-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2390.6 945.73 2355.08 943.13 2345.59 1058.97 2381.07 1063.38 2390.6 945.73"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "M16-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2425.95 948.67 2390.6 945.73 2381.07 1063.38 2416.76 1067.02 2425.95 948.67"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "M16-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2462.68 951.62 2425.95 948.67 2416.76 1067.02 2453.32 1070.66 2462.68 951.62"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "M16-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2515.7 956.47 2462.68 951.62 2453.32 1070.66 2502.53 1076.38 2515.7 956.47"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "M14-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2466.84 895.3 2520.9 899.98 2529.39 822.88 2472.56 818.37 2466.84 895.3"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "M14-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2436.34 815.77 2472.56 818.37 2466.84 895.3 2430.63 892.61 2436.34 815.77"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "M14-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2400.47 812.65 2436.34 815.77 2430.63 892.61 2394.72 889.94 2400.47 812.65"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "M14-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2364.78 809.88 2400.47 812.65 2394.72 889.94 2359.01 887.28 2364.78 809.88"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "M14-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2329.09 807.11 2364.78 809.88 2359.01 887.28 2323.02 883.7 2329.09 807.11"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "M14-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2293.22 804.34 2329.09 807.11 2323.02 883.7 2287.32 880.87 2293.22 804.34"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "M14-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2257.35 801.39 2293.22 804.34 2287.32 880.87 2251.46 878.1 2257.35 801.39"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "M14-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2221.66 798.44 2257.35 801.39 2251.46 878.1 2215.92 875.38 2221.66 798.44"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "M14-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2185.61 795.5 2221.66 798.44 2215.92 875.38 2179.72 871.91 2185.61 795.5"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "M14-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2151.48 792.55 2185.61 795.5 2179.72 871.91 2146.12 869.32 2151.48 792.55"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "M14-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2191.68 718.74 2157.37 716.14 2151.48 792.55 2185.61 795.5 2191.68 718.74"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "M14-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2227.72 721.86 2191.68 718.74 2185.61 795.5 2221.66 798.44 2227.72 721.86"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "M14-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2263.41 724.8 2227.72 721.86 2221.66 798.44 2257.35 801.39 2263.41 724.8"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "M14-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2299.11 727.06 2263.41 724.8 2257.35 801.39 2293.22 804.34 2299.11 727.06"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "M14-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2335.15 730.35 2299.11 727.06 2293.22 804.34 2329.09 807.11 2335.15 730.35"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "M14-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2370.84 733.29 2335.15 730.35 2329.09 807.11 2364.78 809.88 2370.84 733.29"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "M14-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2406.37 736.07 2370.84 733.29 2364.78 809.88 2400.47 812.65 2406.37 736.07"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "M14-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2442.58 738.84 2406.37 736.07 2400.47 812.65 2436.34 815.77 2442.58 738.84"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "M14-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2479.49 742.13 2442.58 738.84 2436.34 815.77 2472.56 818.37 2479.49 742.13"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "M14-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2538.05 747.16 2479.49 742.13 2472.56 818.37 2529.39 822.88 2538.05 747.16"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "M12-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2482.78 686.34 2544.12 691.01 2552.78 614.08 2488.5 609.4 2482.78 686.34"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "M12-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2446.39 683.22 2482.78 686.34 2488.5 609.4 2452.94 606.76 2446.39 683.22"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "M12-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2416.76 603.34 2410.7 680.45 2446.39 683.22 2452.94 606.76 2416.76 603.34"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "M12-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2380.72 600.74 2375 677.33 2410.7 680.45 2416.76 603.34 2380.72 600.74"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "M12-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2345.2 597.62 2339.31 674.38 2375 677.33 2380.72 600.74 2345.2 597.62"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "M12-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2309.51 595.02 2303.44 671.43 2339.31 674.38 2345.2 597.62 2309.51 595.02"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "M12-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2273.81 591.9 2267.75 668.66 2303.44 671.43 2309.51 595.02 2273.81 591.9"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "M12-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2238.12 588.96 2232.23 665.89 2267.75 668.66 2273.81 591.9 2238.12 588.96"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "M12-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2202.08 585.84 2195.84 663.12 2232.23 665.89 2238.12 588.96 2202.08 585.84"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "M12-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2167.25 583.07 2162.05 659.31 2195.84 663.12 2202.08 585.84 2167.25 583.07"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "M12-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2207.97 509.08 2173.14 506.48 2167.25 583.07 2202.08 585.84 2207.97 509.08"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "M12-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2243.66 512.2 2207.97 509.08 2202.08 585.84 2238.12 588.96 2243.66 512.2"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "M12-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2279.53 514.97 2243.66 512.2 2238.12 588.96 2273.81 591.9 2279.53 514.97"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "M12-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2315.4 517.74 2279.53 514.97 2273.81 591.9 2309.51 595.02 2315.4 517.74"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "M12-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2350.92 520.51 2315.4 517.74 2309.51 595.02 2345.2 597.62 2350.92 520.51"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "M12-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2386.96 523.46 2350.92 520.51 2345.2 597.62 2380.72 600.74 2386.96 523.46"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "M12-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2422.83 526.23 2386.96 523.46 2380.72 600.74 2416.76 603.34 2422.83 526.23"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "M12-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2458.52 529 2422.83 526.23 2416.76 603.34 2452.94 606.76 2458.52 529"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "M12-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2494.73 531.95 2458.52 529 2452.94 606.76 2488.5 609.4 2494.73 531.95"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "M12-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2561.79 537.49 2494.73 531.95 2488.5 609.4 2552.78 614.08 2561.79 537.49"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "M10-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2540.13 401.99 2534.41 479.1 2567.86 481.53 2576 404.77 2540.13 401.99"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "M10-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2504.44 399.22 2540.13 401.99 2534.41 479.1 2498.72 476.45 2504.44 399.22"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "M10-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2468.57 396.45 2462.68 473.56 2498.72 476.45 2504.44 399.22 2468.57 396.45"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "M10-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2432.88 393.16 2426.81 470.61 2462.68 473.56 2468.57 396.45 2432.88 393.16"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "M10-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2397.18 390.39 2391.29 467.49 2426.81 470.61 2432.88 393.16 2397.18 390.39"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "M10-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2361.31 387.44 2355.42 464.72 2391.29 467.49 2397.18 390.39 2361.31 387.44"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "M10-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2325.45,384.32c0,.52-5.89,77.8-5.89,77.8l35.87,2.6,5.89-77.28-35.87-3.12Z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "M10-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2289.58 381.89 2283.69 459 2319.56 462.12 2325.45 384.32 2289.58 381.89"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "M10-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2254.23 378.95 2247.82 456.4 2283.69 459 2289.58 381.89 2254.23 378.95"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "M10-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2216.8 376 2211.26 453.28 2247.82 456.4 2254.23 378.95 2216.8 376"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "M10-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2183.36 373.4 2178.34 450.51 2211.26 453.28 2216.8 376 2183.36 373.4"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "M6-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1265.71 260.95 1230.36 255.75 1217.54 344.81 1287.19 354.17 1265.71 260.95"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "M6-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1200.21 251.25 1186.69 339.96 1217.54 344.81 1230.36 255.75 1200.21 251.25"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "M6-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1169.37 246.74 1156.2 334.42 1186.69 339.96 1200.21 251.25 1169.37 246.74"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "M6-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1141.3 242.24 1128.13 329.22 1156.2 334.42 1169.37 246.74 1141.3 242.24"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "M6-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1146.84 206.89 1141.3 242.24 1265.71 260.95 1256 222.83 1146.84 206.89"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "M6-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1153.08 170.85 1146.84 206.89 1256 222.83 1248.72 185.4 1153.08 170.85"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "M6-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1157.93 132.73 1153.08 170.85 1248.72 185.4 1238.33 142.43 1157.93 132.73"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "M5-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-1-2",
    "data-name": "M5-1",
    className: "cls-5",
    points: "1094.16 125.68 1005.22 115.05 998.98 155.02 1087.93 168.65 1094.16 125.68"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "M5-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-2-2",
    "data-name": "M5-2",
    className: "cls-3",
    points: "1083.54 199.15 994.59 185.4 998.98 155.02 1087.93 168.65 1083.54 199.15"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "M5-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-3-2",
    "data-name": "M5-3",
    className: "cls-9",
    points: "1078.69 229.65 989.97 216.25 994.59 185.4 1083.54 199.15 1078.69 229.65"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "M5-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-4-2",
    "data-name": "M5-4",
    className: "cls-2",
    points: "985.58 246.74 1074.06 260.95 1078.69 229.65 989.97 216.25 985.58 246.74"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "M5-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-5-2",
    "data-name": "M5-5",
    className: "cls-6",
    points: "1069.21 290.64 980.5 276.78 985.58 246.74 1074.06 260.95 1069.21 290.64"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "M5-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-6-2",
    "data-name": "M5-6",
    className: "cls-9",
    points: "976.57 304.73 1065.05 318.59 1069.21 290.64 980.5 276.78 976.57 304.73"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "M5-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-7-2",
    "data-name": "M5-7",
    className: "cls-2",
    points: "891.78 263.38 887.62 291.79 976.57 304.73 980.5 276.78 891.78 263.38"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "M5-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-8-2",
    "data-name": "M5-8",
    className: "cls-1",
    points: "896.86 232.65 891.78 263.38 980.5 276.78 985.58 246.74 896.86 232.65"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "M5-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-9-2",
    "data-name": "M5-9",
    className: "cls-8",
    points: "901.48 202.15 896.86 232.65 985.58 246.74 989.97 216.25 901.48 202.15"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "M5-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-10-2",
    "data-name": "M5-10",
    className: "cls-7",
    points: "905.87 172.12 901.48 202.15 989.97 216.25 994.59 185.4 905.87 172.12"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "M5-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-11-2",
    "data-name": "M5-11",
    className: "cls-5",
    points: "910.73 141.85 905.87 172.12 994.59 185.4 998.98 155.02 910.73 141.85"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "M5-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M5-12-2",
    "data-name": "M5-12",
    className: "cls-3",
    points: "916.73 103.96 910.73 141.85 998.98 155.02 1005.22 115.05 916.73 103.96"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "M4-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-1-2",
    "data-name": "M4-1",
    className: "cls-7",
    points: "855.28 96.8 765.87 86.17 761.02 118.29 849.73 132.15 855.28 96.8"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "M4-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-2-2",
    "data-name": "M4-2",
    className: "cls-5",
    points: "845.34 162.65 756.4 148.78 761.02 118.29 849.73 132.15 845.34 162.65"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "M4-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-3-2",
    "data-name": "M4-3",
    className: "cls-3",
    points: "751.78 179.51 840.49 192.68 845.34 162.65 756.4 148.78 751.78 179.51"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "M4-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-4-2",
    "data-name": "M4-4",
    className: "cls-9",
    points: "746.92 210.01 835.64 223.18 840.49 192.68 751.78 179.51 746.92 210.01"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "M4-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-5-2",
    "data-name": "M4-5",
    className: "cls-2",
    points: "742.07 239.81 831.48 253.67 835.64 223.18 746.92 210.01 742.07 239.81"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "M4-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-6-2",
    "data-name": "M4-6",
    className: "cls-5",
    points: "737.68 268.46 826.17 282.32 831.48 253.67 742.07 239.81 737.68 268.46"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "M4-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-7-2",
    "data-name": "M4-7",
    className: "cls-3",
    points: "649.2 254.71 737.68 268.46 742.07 239.81 653.68 226.27 649.2 254.71"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "M4-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-8-2",
    "data-name": "M4-8",
    className: "cls-6",
    points: "746.92 210.01 658.21 195.89 653.68 226.27 742.07 239.81 746.92 210.01"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "M4-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-9-2",
    "data-name": "M4-9",
    className: "cls-1",
    points: "751.78 179.51 662.72 166.12 658.21 195.89 746.92 210.01 751.78 179.51"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "M4-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-10-2",
    "data-name": "M4-10",
    className: "cls-8",
    points: "756.4 148.78 667.38 135.4 662.72 166.12 751.78 179.51 756.4 148.78"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "M4-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "M4-11-2",
    "data-name": "M4-11",
    className: "cls-7",
    points: "765.87 86.17 676.69 75.32 667.38 135.4 756.4 148.78 765.87 86.17"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "M3-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "620.55 68.62 531.6 58.22 523.06 113.21 612 126.84 620.55 68.62"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "M3-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "606.92 157.45 518.2 143.7 523.06 113.21 612 126.84 606.92 157.45"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "M3-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "602.07 188.06 513.81 173.74 518.2 143.7 606.92 157.45 602.07 188.06"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "M3-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "597.68 217.85 508.73 204.46 513.81 173.74 602.07 188.06 597.68 217.85"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "M3-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "593.06 247.36 504.8 233.11 508.73 204.46 597.68 217.85 593.06 247.36"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "M3-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "420.25 191.06 416.09 219.94 504.8 233.11 508.73 204.46 420.25 191.06"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "M3-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "425.1 160.34 420.25 191.06 508.73 204.46 513.81 173.74 425.1 160.34"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "M3-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "429.95 129.84 425.1 160.34 513.81 173.74 518.2 143.7 429.95 129.84"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "M3-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "434.57 99.57 429.95 129.84 518.2 143.7 523.06 113.21 434.57 99.57"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "M3-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "442.66 47.13 434.57 99.57 523.06 113.21 531.6 58.22 442.66 47.13"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "M1-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.01 11.09 48.98 0 44.82 35.35 134.46 48.98 140.01 11.09"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "M1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.35 65.61 44.82 35.35 134.46 48.98 129.7 80.25 41.35 65.61"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "M1-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.66 96.34 125.22 110.2 129.7 80.25 41.35 65.61 37.66 96.34"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "M1-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "33.73 126.37 120.37 139.77 125.22 110.2 37.66 96.34 33.73 126.37"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "M1-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.03 161.26 114.82 173.97 120.37 139.77 33.73 126.37 30.03 161.26"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "M2-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "292.25 29.34 284.86 76.24 373.58 89.64 380.97 39.74 292.25 29.34"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "M2-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "280.24 106.74 368.96 120.37 373.58 89.64 284.86 76.24 280.24 106.74"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "M2-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "275.39 137.46 364.34 150.63 368.96 120.37 280.24 106.74 275.39 137.46"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "M2-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "271.23 167.04 359.48 181.36 364.34 150.63 275.39 137.46 271.23 167.04"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "M2-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "267.07 195.91 355.1 210.47 359.48 181.36 271.23 167.04 267.07 195.91"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "M2-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "177.89 182.4 267.07 195.91 271.23 167.04 182.51 154.56 177.89 182.4"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "M2-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186.9 123.6 182.51 154.56 271.23 167.04 275.39 137.46 186.9 123.6"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "M2-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "191.53 93.11 186.9 123.6 275.39 137.46 280.24 106.74 191.53 93.11"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "M2-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.15,62.38l-4.62,30.73s88.56,14.64,88.72,13.63,4.62-30.5,4.62-30.5l-88.72-13.86Z"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "M2-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "203.08 18.94 196.15 62.38 284.86 76.24 292.25 29.34 203.08 18.94"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "M7-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "56.37 222.71 21.02 217.63 12.71 293.64 47.36 299.19 56.37 222.71"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "M7-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "92.18 227.8 56.37 222.71 47.36 299.19 83.17 304.96 92.18 227.8"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "M7-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.76 233.34 92.18 227.8 83.17 304.96 118.29 310.28 127.76 233.34"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "M7-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "163.11 239.12 127.76 233.34 118.29 310.28 153.4 316.05 163.11 239.12"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "M7-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "198.69 244.43 163.11 239.12 153.4 316.05 188.98 321.6 198.69 244.43"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "M7-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "234.03 249.74 198.69 244.43 188.98 321.6 224.56 326.07 234.03 249.74"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "M7-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "269.84 255.52 234.03 249.74 224.56 326.07 260.83 331.99 269.84 255.52"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "M7-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "305.19 261.07 269.84 255.52 260.83 331.99 295.49 337.31 305.19 261.07"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "M7-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "340.08 266.61 305.19 261.07 295.49 337.31 331.3 342.85 340.08 266.61"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "M7-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "376.12 271.69 340.08 266.61 331.3 342.85 366.42 348.16 376.12 271.69"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "M7-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "411.47 277.24 376.12 271.69 366.42 348.16 402.23 353.94 411.47 277.24"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "M7-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.81 283.24 411.47 277.24 402.23 353.94 437.34 359.25 446.81 283.24"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "M7-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "482.86 289.02 446.81 283.24 437.34 359.25 473.38 364.8 482.86 289.02"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "M7-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "517.97 295.03 482.86 289.02 473.38 364.8 508.73 370.11 517.97 295.03"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "M7-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "576.65 303.81 517.97 295.03 508.73 370.11 533.01 373.67 565.56 378.43 576.65 303.81"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "M7-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "519.82 481.24 533.01 373.67 565.56 378.43 549.93 485.28 519.82 481.24"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "M7-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "502.24 369.14 489.09 476.85 519.82 481.24 533.01 373.67 502.24 369.14"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "M7-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "471.77 364.55 459.06 471.07 489.09 476.85 502.24 369.14 471.77 364.55"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "M7-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "441.35 359.87 428.79 465.53 459.06 471.07 471.77 364.55 441.35 359.87"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "M7-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "410.63 355.21 398.53 460.68 428.79 465.53 441.35 359.87 410.63 355.21"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "M7-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "381.3 350.56 367.8 456.29 398.53 460.68 410.63 355.21 381.3 350.56"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "M7-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "350.04 345.69 337.77 451.44 367.8 456.29 381.3 350.56 350.04 345.69"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "M7-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "319.62 341.04 306.58 446.81 337.77 451.44 350.04 345.69 319.62 341.04"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "M7-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "289.55 336.4 275.85 442.66 306.58 446.81 319.62 341.04 289.55 336.4"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "M7-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "258.99 331.99 246.05 438.04 275.85 442.66 289.55 336.4 258.99 331.99"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "M7-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "228.07 326.64 215.09 434.34 246.05 438.04 258.99 331.99 228.07 326.64"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "M7-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "198.69 322.82 184.13 429.26 215.09 434.34 228.07 326.64 198.69 322.82"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "M7-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "167.49 318.25 154.56 424.64 184.13 429.26 198.69 322.82 167.49 318.25"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "M7-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.29 313.4 123.83 420.25 154.56 424.64 167.49 318.25 137.29 313.4"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "M7-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "107.02 308.57 93.57 415.63 123.83 420.25 137.29 313.4 107.02 308.57"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "M7-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.46 303.88 63.3 411 93.57 415.63 107.02 308.57 76.46 303.88"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "M7-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "46.21 299.19 33.04 405.92 63.3 411 76.46 303.88 46.21 299.19"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "M7-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.71 293.64 0 400.38 33.04 405.92 46.21 299.19 12.71 293.64"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "M8-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "669.53 316.74 634.41 311.43 620.32 404.3 654.97 410.08 669.53 316.74"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "M8-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "699.79 321.6 669.53 316.74 654.97 410.08 684.62 414.7 699.79 321.6"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "M8-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "730.29 326.45 699.79 321.6 684.62 414.7 715.88 419.8 730.29 326.45"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "M8-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "760.56 331.07 730.29 326.45 715.88 419.8 746.1 424.46 760.56 331.07"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "M8-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "790.82 336.15 760.56 331.07 746.1 424.46 776.61 429.19 790.82 336.15"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "M8-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "821.09 340.54 790.82 336.15 776.61 429.19 806.76 434.8 821.09 340.54"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "M8-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "851.81 345.85 821.09 340.54 806.76 434.8 837.38 439.45 851.81 345.85"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "M8-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "882.08 350.24 851.81 345.85 837.38 439.45 867.7 444.13 882.08 350.24"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "M8-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "912.34 355.1 882.08 350.24 867.7 444.13 898.39 448.83 912.34 355.1"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "M8-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "942.84 359.48 912.34 355.1 898.39 448.83 928.67 453.34 942.84 359.48"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "M8-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "973.34 364.57 942.84 359.48 928.67 453.34 959.17 457.94 973.34 364.57"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "M8-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1003.83 369.42 973.34 364.57 959.17 457.94 989.44 462.53 1003.83 369.42"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "M8-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1034.56 373.58 1003.83 369.42 989.44 462.53 1020.02 467.26 1034.56 373.58"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "M8-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1064.82 377.97 1034.56 373.58 1020.02 467.26 1050.01 471.92 1064.82 377.97"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "M8-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1094.86 383.05 1064.82 377.97 1050.01 471.92 1080.29 476.69 1094.86 383.05"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "M8-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1125.82 387.21 1094.86 383.05 1080.29 476.69 1110.47 481.38 1125.82 387.21"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "M8-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1156.2 392.29 1125.82 387.21 1110.47 481.38 1140.95 486.35 1156.2 392.29"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "M8-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1186.69 396.68 1156.2 392.29 1140.95 486.35 1171.43 491.29 1186.69 396.68"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "M8-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1216.38 401.76 1186.69 396.68 1171.43 491.29 1202.06 495.1 1216.38 401.76"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "M8-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1247.34 406.38 1216.38 401.76 1202.06 495.1 1232.99 499.85 1247.34 406.38"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "M8-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1278.3 411.47 1247.34 406.38 1232.99 499.85 1243.01 501.39 1264.42 504.67 1278.3 411.47"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "M8-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1302.79 415.86 1278.3 411.47 1264.42 504.67 1309.54 511.39 1325.33 513.74 1302.79 415.86"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "M8-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1294.88 599.76 1346.22 607.15 1325.33 513.74 1308.53 511.24 1294.88 599.76"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "M8-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1278.3 506.74 1265.06 595.62 1294.88 599.76 1308.53 511.24 1278.3 506.74"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "M8-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1229.32 590.52 1266.06 595.76 1278.3 506.74 1243.01 501.39 1229.32 590.52"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "M8-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1208.1 496.03 1193.9 584.51 1229.32 590.52 1243.01 501.39 1208.1 496.03"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "M8-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1171.43 491.29 1158.39 578.73 1193.9 584.51 1208.1 496.03 1171.43 491.29"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "M8-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1136.71 485.66 1122.4 573.47 1158.39 578.73 1171.43 491.29 1136.71 485.66"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "M8-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1106.67 480.79 1091.62 568.34 1122.4 573.47 1136.71 485.66 1106.67 480.79"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "M8-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1070.57 475.16 1056.68 563.32 1091.62 568.34 1106.67 480.79 1070.57 475.16"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "M8-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1034.56 469.52 1020.82 558.05 1056.68 563.32 1070.57 475.16 1034.56 469.52"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "M8-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "999.9 464.15 986.15 553.11 1020.82 558.05 1034.56 469.52 999.9 464.15"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "M8-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "964.57 458.76 951 547.08 986.15 553.11 999.9 464.15 964.57 458.76"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "M8-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "928.67 453.34 915.57 541.27 951 547.08 964.57 458.76 928.67 453.34"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "M8-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "898.39 448.83 884.39 536.45 915.57 541.27 928.67 453.34 898.39 448.83"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "M8-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "867.7 444.13 854.19 532.38 884.39 536.45 898.39 448.83 867.7 444.13"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "M8-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "837.38 439.45 824.06 527.13 854.19 532.38 867.7 444.13 837.38 439.45"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "M8-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "806.76 434.8 793.34 523.16 824.06 527.13 837.38 439.45 806.76 434.8"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "M8-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "776.61 429.19 776.46 430.2 762.81 518.35 793.34 523.16 806.76 434.8 776.61 429.19"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "M8-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "746.1 424.46 732.32 513.74 762.81 518.35 776.61 429.19 746.1 424.46"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "M8-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "715.88 419.8 702.12 508.96 732.32 513.74 746.1 424.46 715.88 419.8"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "M8-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "684.62 414.7 671.61 504.57 702.12 508.96 715.88 419.8 684.62 414.7"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "M8-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "654.97 410.08 641.13 498.89 671.61 504.57 686.21 414.96 654.97 410.08"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "M8-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "620.32 404.3 607.15 493.25 641.27 497.98 654.97 410.08 620.32 404.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenderos);
export default __webpack_public_path__ + "static/media/senderos.5a218a21bf64273b570bbd9e85af912e.svg";
export { ForwardRef as ReactComponent };